import { logError } from '@/src/utils/logError'

export const ClevertapAndroid = {
    event(name: string, payload: Object) {
        try {
            if (window.CleverTap) {
                if (payload) {
                    window.CleverTap.pushEvent(name, JSON.stringify(payload));
                } else {
                    window.CleverTap.pushEvent(name);
                }
            }
            if (window.ClevertapInterface) {
                if (payload) {
                    window.ClevertapInterface.pushEvent(name, JSON.stringify(payload))
                } else {
                    window.ClevertapInterface.pushEvent(name)
                }
            }
        } catch (e) {
            logError('ClevertapAndroid', e)
        }
    }
}
